import { get, prefix } from '../index';
import { getDomainBaseUrl } from '@ugc-utils/domains';

export const getThumbStatus = (
  ids: string[]
): Promise<
  {
    id: string;
    vote: boolean;
  }[]
> => {
  const params = new URLSearchParams();
  ids.forEach(item => params.append('ids', item));
  return get(`${getDomainBaseUrl('catalog')}${prefix}/api/helpful/status`, params, {}, false) as Promise<
    {
      id: string;
      vote: boolean;
    }[]
  >;
};
